"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.aggregate3Signature = void 0;
exports.aggregate3Signature = '0x82ad56cb';
//# sourceMappingURL=contract.js.map